var map = {
	"./staging_upsell_apply_discount_fallback.json": [
		6474,
		6474
	],
	"./staging_upsell_new_h_2_fallback.json": [
		94423,
		4423
	],
	"./staging_upsell_new_h_fallback.json": [
		70271,
		271
	],
	"./staging_upsell_new_t_fallback.json": [
		63895,
		3895
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 27065;
module.exports = webpackAsyncContext;